export default __webpack_public_path__ + "static/media/portfolio-cia-2.c03a0139.jpg";